
import { Vue, Component } from 'vue-property-decorator';
import loading from '@/components/loading.vue';
import { Invoice as InvoiceAPI } from '@/service';
import md5 from 'js-md5';

@Component({
    name: 'Invoice',
    components: {
        loading,
    },
})
export default class Invoice extends Vue {
    public $message!: any;

    private msg: string = '';
    private showLoading: boolean = true;
    private canIApply: boolean = false;
    private orderInfo: Record<string, any> | null = null;
    private link: string = '';

    public apply() {
        const url = `${location.origin}/jump?j=${encodeURIComponent(this.link)}`;
        if (window.parent === window.self) {
            location.href = url;
            return;
        }

        const mchData: any = {
            action: 'jumpOut',
            jumpOutUrl: url,
        };
        const postData = JSON.stringify(mchData);
        parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    }

    public checkCode(platformSn: string, checkCodeStr: string): boolean {
        const url = `${location.origin}${location.pathname}?sub_mch_id=${this.$route.query.sub_mch_id}&out_trade_no=${this.$route.query.out_trade_no}&transaction_id=${platformSn}`;
        return md5(url) === checkCodeStr;
    }

    public onReadyCallParentFrame(type: 'custom' | 'official') {
        if (window.parent === window.self) {
            return;
        }

        const mchData: any = {
            action: 'onIframeReady',
        };
        switch (type) {
            case 'official':
                // no break;
            case 'custom':
                mchData.displayStyle = 'SHOW_CUSTOM_PAGE';
                break;
            default:
                mchData.displayStyle = 'SHOW_OFFICIAL_PAGE';
                break;
        }
        const postData = JSON.stringify(mchData);
        parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    }

    private async created() {
        try {
            // if (navigator.userAgent.match('MicroMessenger')) {
                window.rrybWxGoldPlan();
            // }
        } catch (error) {
            console.warn(error);
        }
        const { sub_mch_id, out_trade_no, check_code } = this.$route.query;

        if (!sub_mch_id || !out_trade_no || !check_code) {
            this.$message('订单参数丢失 ' + location.search);
            this.msg = '订单参数丢失 ' + location.search;
            this.onReadyCallParentFrame('official');
        } else {
            console.log('$route.query:', this.$route.query);
            try {
                const { rt_code, data, msg } = await InvoiceAPI.thirdLink({
                    order_sn: out_trade_no,
                    link: location.href,
                });

                if (rt_code === 1014) {
                    throw '';
                } else if (rt_code !== 0) {
                    throw msg;
                }
                if (!data.link) {
                    this.$message('开票链接丢失');
                    throw '开票链接丢失';
                }

                this.link = data.link;
                this.canIApply = true;
                this.onReadyCallParentFrame('custom');
            } catch (error) {
                console.warn(error);
                this.msg = '('
                    + (typeof error === 'string'
                        ? error
                        : error.message || error.data.msg)
                    + ')';
                this.onReadyCallParentFrame('official');
            } finally {
                this.showLoading = false;
            }
        }
    }
}
